<template>
  <fieldset>
    <legend>Seções</legend>
    <router-link id="btn-add-field" :to="{name: 'FormSectionDetail', params: { reqType: reqType, id: null }}" type="button" class="btn btn-success">
        <span class="glyphicon glyphicon-plus"></span> Adicionar Seção
    </router-link>
    <br><br>
    <loader v-if="updating"></loader>
      <div v-if="sections.length == 0" class="alert alert-info" id="msg-no-sections">
              Formulário ainda não possui seções
      </div>
      <draggable v-model="sections" @end="checkMove" class="list-group" v-else>
        <div class="list-group-item" v-for="s in sections">
          <h4 class="list-group-item-heading">
              {{s.name}}
              <span class="pull-right">
                <span class="badge">{{counts[s.objectId]}} campo(s)</span>
                <router-link :to="{name: 'FormSectionDetail', params: { reqType: reqType, id: s.objectId }}" type="button" class="btn btn-xs btn-primary" title="Editar Seção">
                  <span class="glyphicon glyphicon-edit"></span> Editar
                </router-link>
                <button @click="remove(s)" class="btn btn-xs btn-danger" title="Remover Seção">
                  <span class="glyphicon glyphicon-remove"></span> Remover
                </button>
              </span>
          </h4>
          <p class="list-group-item-text">{{s.description }}</p>
        </div>
      </draggable>     
    
  </fieldset>
</template>

<script>
import { GlobalChannel, Parse, miniToastr } from '../Global'
import Loader from './util/Loader'
import draggable from 'vuedraggable'
import { handleParseError } from './util/ErrorHandling'

export default {
  components: {
    draggable,
    Loader
  },
  props: ['reqType'],
  data () {
    return {
      positions: [],
      sections: [],
      sectionsParse: [],
      counts: [],
      updating: false
    }
  },
  mounted () {
    let self = this
    GlobalChannel.$on('new_form_section', () => {
      self.refresh()
    })
    this.refresh()
  },
  methods: {
    refresh () {
      if (this.reqType) {
        let self = this
        self.loading = true
        let params = { requestId: self.reqType, sectionId: self.sectionId }
        Parse.Cloud.run('listFormSections', params).then(results => {
          self.sectionsParse = results.data
          self.sections = results.data.map(r => r.toJSON())
          self.counts = results.counts
          self.loading = false
        }).fail(error => {
          self.loading = false
          handleParseError(self, error)
        })
      }
    },
    checkMove (evt) {
      if (evt.newIndex !== evt.oldIndex) {
        let self = this
        self.updating = true
        let updateList = []
        self.sections.forEach((section, i) => {
          let sectionParse = self.sectionsParse.find(item => item.id === section.objectId)
          sectionParse.set('order', i)
          updateList.push(sectionParse)
        })
        Parse.Object.saveAll(updateList).then(results => {
          self.sectionsParse = results
          self.updating = false
        }).fail(error => {
          self.updating = false
          handleParseError(self, error)
        })
      }
    },
    remove (section) {
      if (confirm('Deseja realmente remover o item?')) {
        let self = this
        self.loading = true
        let params = { sectionId: section.objectId }
        Parse.Cloud.run('removeFormSection', params).then(results => {
          self.loading = false
          miniToastr.success('Removido com sucesso.')
          self.refresh()
        }).fail(error => {
          self.loading = false
          handleParseError(self, error)
        })
      }
    }
  },
  watch: {
    'reqType': (val, oldValue) => {
      this.refresh()
    }
  }
}
</script>
<style scoped>
.required{
  font-size: 10px;
  color: #c71916;
}
.modal-container {
  width: 500px !important;
}
</style>



// WEBPACK FOOTER //
// FormSectionList.vue?61ae49ed